import { render } from "./QueryOrders.vue?vue&type=template&id=55f82038"
import script from "./QueryOrders.vue?vue&type=script&lang=js"
export * from "./QueryOrders.vue?vue&type=script&lang=js"

import "./QueryOrders.vue?vue&type=style&index=0&id=55f82038&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__